import React, { useMemo } from 'react';
import moment from 'moment';
import { pipe, props, filter, join, cond, test, T } from 'ramda';
import PropTypes from 'prop-types';

import ArrowRight from 'assets/svg-icons/ArrowRight';

import { Container, Button, ContentContainer, LeftSide, RightSide, Kind, CreatedDate } from './styles';

const Panel = ({ redirectBack, user, email, kind, date }) => {
  const name = useMemo(() => pipe(props(['lastname', 'firstname']), filter(Boolean), join(', '))(user), [user]);
  const color = useMemo(
    () =>
      cond([
        [test(/info/i), () => '#009838'],
        [test(/error/i), () => '#f00'],
        [T, () => ''],
      ])(kind),
    [kind]
  );

  return (
    <Container>
      <Button type="button" onClick={redirectBack}>
        <ArrowRight />
      </Button>
      <ContentContainer>
        <LeftSide>{name || email || ''}</LeftSide>
        <RightSide>
          <Kind $color={color}>{kind}</Kind>
          <CreatedDate>{date && moment(date).format('DD.MM.YYYY')}</CreatedDate>
        </RightSide>
      </ContentContainer>
    </Container>
  );
};

Panel.defaultProps = {
  user: {},
  email: '',
  kind: 'INFO',
  date: null,
};

Panel.propTypes = {
  redirectBack: PropTypes.func.isRequired,
  user: PropTypes.shape({
    lastname: PropTypes.string,
    firstname: PropTypes.string,
  }),
  email: PropTypes.string,
  kind: PropTypes.string,
  date: PropTypes.string,
};

export default Panel;
